import React from "react";
import styled from "styled-components";

import { colours } from "@/utils";
import Device from "@/utils/device";
import FloatingTextBox from "../marketing/FloatingTextBox";

const OldSessionsHouseHeroContent = () => {
  return (
    <S.Section>
      <S.TextBoxContainer>
        <FloatingTextBox
          animationColour={colours.marketingYellow}
          colour={colours.marketingYellowPale}
          copy="Welcome to AllBright’s Next Chapter: Our Sophisticated New Home for Connection, Learning & Inspiration"
          linkText="Speak to our memberships team"
          linkUrl="https://calendly.com/tyra-bateman-allbright"
          target="_blank"
          title={["AllBright@", <br key="br" />, "Old Sessions House"]}
        />
      </S.TextBoxContainer>
      <S.Line />
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  position: relative;
  aspect-ratio: 1/2;
  width: 100%;
  background-image: url("/images/old-sessions-house/pool-chairs.png");
  background-position: center;

  display: flex;
  flex-direction: column-reverse;
  align-items: center;

  @supports not (aspect-ratio: 1/2) {
    &::before {
      float: left;
      padding-top: 200%;
      content: "";
    }

    &::after {
      display: block;
      content: "";
      clear: both;
    }
  }

  @media (${Device.mobile}) {
    aspect-ratio: 1/1.2;

    @supports not (aspect-ratio: 1/1.2) {
      &::before {
        float: left;
        padding-top: 120%;
        content: "";
      }

      &::after {
        display: block;
        content: "";
        clear: both;
      }
    }
  }

  @media (${Device.tablet}) {
    background-image: url("/images/old-sessions-house/pool-view.jpg");
    background-position: bottom;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    aspect-ratio: 1.5/1;

    @supports not (aspect-ratio: 1.5/1) {
      &::before {
        float: left;
        padding-top: 66%;
        content: "";
      }

      &::after {
        display: block;
        content: "";
        clear: both;
      }
    }
  }

  @media (${Device.desktop}) {
    aspect-ratio: 2.2/1;

    @supports not (aspect-ratio: 2.2/1) {
      &::before {
        float: left;
        padding-top: 45%;
        content: "";
      }

      &::after {
        display: block;
        content: "";
        clear: both;
      }
    }
  }
`;

S.TextBoxContainer = styled.div`
  position: absolute;
  width: 85%;
  top: 5%;
  right: 5%;

  @media (${Device.mobile}) {
    position: absolute;
    width: 80%;
    right: 0;
    top: 5%;
  }

  @media (${Device.tablet}) {
    position: absolute;
    width: 60%;
    right: 0;
    top: 5%;
  }

  @media (${Device.desktop}) {
    position: absolute;
    width: 40%;
    right: 0;
    top: 10%;
  }
`;

S.Line = styled.div`
  height: 30px;
  width: 100%;
  background: ${colours.marketingYellowPale};
`;

export default OldSessionsHouseHeroContent;
